import { combineReducers } from "redux";
import { getErrorReducer, getStatusReducer } from "../utils/reducer-generators";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils/get-action-types";
import {
  FETCH_NEW_TOKEN,
  FETCH_TOKEN,
  FORGOT_PASSWORD_SEND_SMS,
  FORGOT_PASSWORD_UPDATE_PASSWORD,
  FORGOT_PASSWORD_VERIFY_CODE,
  LOGOUT,
} from "../constants/auth";
import { ACCESS_TOKEN_KEY, ANONYMOUS, AUTHENTICATED, ERROR, INIT, LOADING, REFRESH_TOKEN_KEY } from "../constants";
import { Status } from "../types";
import { Action, ForgotPasswordState } from "../models/auth";

function status(state: Status = INIT, action: Action): Status {
  switch (action.type) {
    case getRequestActionType(FETCH_TOKEN):
      return LOADING;
    case getSuccessActionType(FETCH_TOKEN):
      localStorage.setItem(ACCESS_TOKEN_KEY, action.payload.access.token);
      localStorage.setItem(REFRESH_TOKEN_KEY, action.payload.refresh.token);
      return AUTHENTICATED;
    case getFailureActionType(FETCH_TOKEN):
      return ERROR;
    case LOGOUT:
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      if (window) window.location.href = "/";
      return ANONYMOUS;
    case getSuccessActionType(FETCH_NEW_TOKEN):
      localStorage.setItem(ACCESS_TOKEN_KEY, action.payload.access.token);
      return state;
    default:
      return state;
  }
}

function forgotPasswordData(state: ForgotPasswordState = { accessToken: null }, action: Action): ForgotPasswordState {
  switch (action.type) {
    case getSuccessActionType(FORGOT_PASSWORD_VERIFY_CODE):
      return { accessToken: action.payload.key };
    default:
      return state;
  }
}

const actionsList = [
  FETCH_TOKEN,
  FORGOT_PASSWORD_SEND_SMS,
  FORGOT_PASSWORD_VERIFY_CODE,
  FORGOT_PASSWORD_UPDATE_PASSWORD,
];

export default combineReducers({
  status,
  forgotPasswordData,
  forgotPasswordStepOneStatus: getStatusReducer([FORGOT_PASSWORD_SEND_SMS]),
  forgotPasswordStepTwoStatus: getStatusReducer([FORGOT_PASSWORD_VERIFY_CODE]),
  forgotPasswordStepThreeStatus: getStatusReducer([FORGOT_PASSWORD_UPDATE_PASSWORD]),
  error: getErrorReducer(actionsList),
});
